import { gql } from '@apollo/client'

export const Query = gql`
  query EventContacts(
    $companyId: ID!,
    $eventId: ID!,
    $filters: EventContactFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventContacts(filters: $filters, after: $after, before: $before, first: $first, last: $last) {
          nodes {
            id
            name
            email
            phone
            color
            contactType
          }
          pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
        }
      }
    }
  }
`
